import 'react'

const DoneIcon = () => {
  return (
    <svg
      aria-hidden="true"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="16" height="16" rx="8" fill="#37A598" />
      <path
        d="M4.5 8L7.5 11L12.5 5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default DoneIcon
